import moment from 'moment';

export function formatSendDate(sendDate: Date) {
  return moment(sendDate).format('dddd, D MMMM YYYY, HH:mm');
}
